import * as VueRouter from 'vue-router'
import { authGuard } from '@auth0/auth0-vue'
import HomePage from 'Pages/HomePage.vue'
import Aircraft from 'Pages/AircraftPage.vue'
import ImageReviewPage from 'Pages/ImageReviewPage.vue'
import PageNotFound from 'Pages/PageNotFound.vue'
import PlaygroundPage from 'Pages/PlaygroundPage.vue'
import ReportDashboardPage from '@/pages/ReportDashboardPage.vue'
import ReportSummaryExporter from '@/pages/ReportSummaryExporter.vue'
import { useUserStore } from 'Store/userStore'
import { useFilterStore } from 'Store/filterStore'

const env = import.meta.env.MODE

export enum JeteyeRoutes {
  Home = 'Home',
  SummaryReport = 'SummaryReport',
  Aircraft = 'Aircraft',
  ImageReview = 'ImageReview',
  SummaryReportExport = 'SummaryReportExport',
}

const routes = [
  {
    path: '/',
    name: JeteyeRoutes.Home,
    component: HomePage,
    meta: {
      label: 'Home',
    },
  },
  {
    path: '/report',
    name: JeteyeRoutes.SummaryReport,
    component: ReportDashboardPage,
    meta: {
      label: 'SummaryReport',
    },
  },
  {
    path: '/report/export',
    name: JeteyeRoutes.SummaryReportExport,
    component: ReportSummaryExporter,
    meta: {
      label: 'SummaryReportExport',
    },
  },
  {
    path: '/aircraft/:aircraftUUID',
    name: JeteyeRoutes.Aircraft,
    component: Aircraft,
    meta: {
      label: ':aircraftUUID',
    },
  },
  {
    path: '/review',
    name: JeteyeRoutes.ImageReview,
    component: ImageReviewPage,
  },
  { path: '/:catchAll(.*)', name: 'pageNotFound', component: PageNotFound },
]

if (env === 'development') {
  routes.push({
    path: '/playground/',
    name: 'playground',
    component: PlaygroundPage,
  })
}

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes,
})

router.beforeEach(async (to, from) => {
  const isAuthenticated = await authGuard(to)
  const filterStore = useFilterStore()

  filterStore.invalidateFilterState()

  if (isAuthenticated) {
    const userStore = useUserStore()
    userStore.setUserData()
  }

  return isAuthenticated
})

export { router }
